const Constants = {

    "FORM_TITLE_EXPIRED": {
        "es": "Estamos haciendo mejoras",
        "ca": "Estem fent millores",
        "pt": "Estamos a melhorar o nosso site",
        "en": "We're currently making improvements "
    },

    "FORM_CLIENT_OACSUPPORT": {
        "es": "https://cloud.news.fundacionlacaixa.org/form01?lang=es&idf=contacta",
        "ca": "https://cloud.news.fundaciolacaixa.org/form01?lang=ca&idf=contacta",
        "en": "https://cloud.news.lacaixafoundation.org/form01?lang=en&idf=contact",
        "pt": "https://cloud.news.fundacaolacaixa.org/form01?lang=pt&idf=contact"
    },

    "FORM_LABEL_EXPIRED": {
        "es": "El formulario al que intenta acceder no está disponible temporalmente.<br/>Por favor, intente acceder un poco más tarde.<br/>¡Lamentamos las molestias!",
        "ca": "El formulari al qual intenta accedir no està disponible temporalment.<br/>Sisplau, miri d’accedir-hi una mica més tard.<br/>Lamentem les molèsties!",
        "pt": "O formulário a que está a tentar aceder está temporariamente indisponível.<br/>Por favor, tente mais tarde.<br/>Lamentamos o incómodo.",
        "en": "The form you're trying to access is temporarily unavailable.<br/>Please try to log on a little later.<br/>We're sorry for the inconvenience!"
    },
    "AFORO_COMPLETO": {
        "es": "Estamos haciendo mejoras",
        "ca": "Estem fent millores",
        "pt": "Estamos a melhorar o nosso site",
        "en": "We're currently making improvements "
    },
    "TEST_MODE": {
        "es": "Este formulario está en pruebas y no puede ser utilizado para captar datos reales. Si lo encuentra correcto, solicite al operador su activación.",
        "ca": "Aquest formulari està en proves i no es pot utilitzar per captar dades reals. Si ho trobeu correcte, sol·liciteu a l'operador la vostra activació.",
        "pt": "Este formulário está em teste e não pode ser usado para capturar dados reais. Se achar correto, peça ao operador sua ativação.",
        "en": "This form is in tested and cannot be used to capture real data. If you find it is correct ask the operator its activation."
    },
    "CHOOSE_AN_OPTION": {
        "es": "Seleccione una opción.",
        "ca": "Trieu una opció.",
        "pt": "Escolha uma opção.",
        "en": "Choose an option."
    },
    "CHECKBOX_CHECKALL": {
        "es": "Marcar todas",
        "ca": "Marcar tots",
        "pt": "Marcar todos",
        "en": "Mark all"
    },
    "NO_OPTIONS_AVAILABLE": {
        "es": "No hay opciones disponibles.",
        "ca": "No hi ha opcions disponibles.",
        "pt": "Nenhuma opção disponível.",
        "en": "No options available."
    },
    "VALID_LANGUAGES": ['ca', 'es', 'pt', 'en'] ,
    "DEFAULT_LANG": 'es',
    "KEY_CODES":{
        "BSPACE": 8,
        "TAB": 9,
        "ENTER": 13,
        "SPACE": 32,
        "LEFT": 37,
        "UP": 38,
        "RIGHT": 39,
        "DOWN": 40,
        "DEL": 46
    }

}
export { Constants };